// common/useHostMiddleware.js
const MARKETING_HOSTS = ['localhost', 'solio.reyzap.com', 'www.solio.reyzap.com'];
const BASE_DOMAIN   = process.env.REACT_APP_BASE_DOMAIN || 'reyzap.com';
const RESERVED_SUBS = ['admin', 'api', 'www', 'mail', 'staging', 'internal', 'ai'];

export function useHostMiddleware() {
  const host = window.location.hostname.toLowerCase().replace(/:\d+$/, '');
  console.log("============", host)
  // localhost or main marketing domain → owner/marketing
  if (MARKETING_HOSTS.includes(host)) {
    return { isOwner: true};
  }
  else{
   return { isOwner: false}
  }
}